import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Suche',
  },
  searchResults: {
    showMore: 'Mehr Ergebnisse anzeigen',
    noResults: 'Schade, wir konnten leider keine passenden Suchergebnisse für Ihre Eingabe <b>{storeSearchTerm}</b> finden.',
    noResultsHint: 'Nicht aufgeben! Überprüfen Sie die Schreibweise oder suchen Sie weniger spezifisch.',
    badges: {
      pfsc: 'PEFC',
      fsc: 'FSC®',
      fsc_pfsc: 'FSC® oder PEFC',
      ecofriendly: 'Umweltmaterialien',
      overnight: 'Express und Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online gestalten',
    },
    taglines: {
      home: 'Mehr erfahren',
      text: 'Mehr erfahren',
      themes: 'Mehr erfahren',
      external: 'Mehr erfahren',
      info: 'Mehr erfahren',
      category: 'Mehr erfahren',
      content: 'Mehr erfahren',
      product: 'Jetzt konfigurieren',
    },
    headings: {
      categories: 'Produktkategorien',
      products: 'Produkte',
      external: 'Weiteres',
    },
    slider: {
      previousSlide: 'Vorherige Inhalte anzeigen',
      nextSlide: 'Nächste Inhalte anzeigen',
    },
  },
  searchInput: {
    inputTooShortError: 'Ihr Suchbegriff ist zu kurz (min 2)',
    results: 'Treffer',
    result: 'Ergebnis',
    youSearchFor: 'Ergebnisse für ',
    suggestedTerm: {
      didYouMean: 'Meinten Sie',
      resultsFor: 'Stattdessen suchen nach',
      didYouMeanPostFix: '?',
      resultsForPostFix: '',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Listen-Ansicht',
      gridButtonTooltip: 'Kachel-Ansicht',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Alle Filter löschen',
        resetFilters: 'Zurücksetzen',
      },
      buttonsPanel: {
        filterLabel: 'Filter',
        buttonsTooltipLabel: 'Ansicht',
        resultLabel: 'Suchergebnisse',
      },
      contexts:
        {
          product: 'Produkte',
          content: 'Sonstiges',
          all: 'all',
          category: 'Produktkategorien',
          external: 'Weiteres',
        },
    },
    breadcrumbs: {
      start: 'Start',
      search: 'Suche',
    },
  },
  sideBar: {
    filter: 'Filter',
    filterOverwrite: {
      category: {
        text: 'Kategorien',
      },
      rootCategory: {
        text: 'Kategorien',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC®',
          logoPfsc: 'PEFC',
          logoFscPfsc: 'FSC®/PEFC',
          samedayAvailable: 'Sameday',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Umweltmaterialien',
          onlineDesign: 'Online gestalten',
          new: 'Neuheiten',
        },
      },
    },
    more: 'mehr',
    less: 'weniger',
  },
  common: {
    warnings: {
      server401: 'Ihre Sitzung ist abgelaufen und Sie müssen sich erneut anmelden. Sie werden sofort zur Anmeldung weitergeleitet.',
      server403: 'Die Anfrage wurde nicht bearbeitet, da keine gültigen Authentifizierungsdaten vorliegen. Bitte laden Sie die Seite neu oder wenden Sie sich an unseren Kundendienst.',
      default: 'Es ist ein Fehler auf dem Server aufgetreten. Bitte laden Sie die Seite neu oder kontaktieren Sie unseren Kundendienst.',
    },
    errors: {
      server400: 'Die Anfrage war fehlerhaft formuliert. Bitte laden Sie die Seite neu oder kontaktieren Sie unseren Kundendienst.',
      server404: '404 Seite nicht gefunden. Bitte gehen Sie zur vorherigen Seite oder kontaktieren Sie unseren Kundendienst.',
      server500: 'Es ist ein Fehler auf dem Server aufgetreten. Bitte laden Sie die Seite neu oder kontaktieren Sie unseren Kundendienst.',
      server501: 'Auf dem Server ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu oder wenden Sie sich an unseren Kundendienst.',
      server502: 'Es ist ein Fehler auf dem Server aufgetreten und Sie erhalten eine ungültige Antwort. Bitte laden Sie die Seite neu oder wenden Sie sich an unseren Kundendienst.',
      server503: 'Es ist ein Fehler auf dem Server aufgetreten. Bitte laden Sie die Seite neu oder wenden Sie sich an unseren Kundendienst.',
      server504: 'Es ist ein Fehler auf dem Server aufgetreten. Bitte laden Sie die Seite neu oder kontaktieren Sie unseren Kundendienst.',
      default: 'Der Server hat ein Problem mit der Anfrage. Bitte laden Sie die Seite neu oder wenden Sie sich an unseren Kundendienst.',
    },
  },
};
export default translation;
